import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SubscriptionsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"subscriptions"}/>
}
